import logo from '../assets/images/logo.jpeg';
const PRODUCT_LINKS = [
  'Sona Masoori Rice','Basmati Rice','HMT Rice',
  'Sunflower Oil','Groundnut Oil','Toor Dal',
  'Wheat Flour','Spices & Masalas',
];

export default function Footer({ setPage }) {
  const go = (id) => { setPage(id); window.scrollTo(0, 0); };
  return (
    <footer style={{ background: '#1A0F05', color: 'rgba(255,255,255,0.65)' }}>
      <div style={{ height: 4, background: 'linear-gradient(to right, #E8610A, #FF7D2A, #E8610A)' }} />
      <div className="container" style={{ padding: '72px 5vw 52px' }}>
        <div style={{ display: 'grid', gap: 48 }} className="footer-cols">
          {/* Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 20 }}>
              <img src={logo} alt="SLN E SHOP TRADERS" style={{ height: 50, width: 'auto', objectFit: 'contain', background: '#fff', borderRadius: 8, padding: 4 }} />
              <div>
                <div style={{ fontFamily:"'Playfair Display',serif", fontWeight: 700, color: '#fff', fontSize: '1.25rem', lineHeight: 1.15 }}>
                  SLN <span style={{ color: '#FF7D2A' }}>E SHOP</span>
                </div>
                <div style={{ fontSize: '.6rem', color: 'rgba(255,255,255,.38)', letterSpacing: '.08em', textTransform: 'uppercase' }}>TRADERS</div>
              </div>
            </div>
            <p style={{ fontSize: '.87rem', lineHeight: 1.85, marginBottom: 26, maxWidth: 300 }}>
              Hyderabad's trusted B2B wholesale delivery partner for kirana stores, restaurants and provision shops. Quality products, on-time delivery, GST invoice — always.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {[
                { i: '📞', t: '+91 91219 27878' },
                { i: '📧', t: 'info@eshopglobaltraders.in' },
                { i: '📍', t: '8-12-96/s/205, ZP Rd, Sriramana Colony, Lb nagar, Hyderabad, Telangana 500079' },
                { i: '🕐', t: 'Mon – Sat: 8 AM – 8 PM' },
              ].map((c, i) => (
                <div key={i} style={{ display: 'flex', gap: 10, fontSize: '.83rem', alignItems: 'center' }}>
                  <span>{c.i}</span><span>{c.t}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <div style={{ fontFamily:"'Playfair Display',serif", fontWeight: 600, color: '#fff', marginBottom: 18, fontSize: '1rem' }}>Quick Links</div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 12 }}>
              {[['home','Home'],['about','About Us'],['products','Products'],['delivery','Delivery Process'],['contact','Contact Us']].map(([id,label]) => (
                <li key={id}>
                  <button onClick={() => go(id)} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, fontSize: '.84rem', color: 'rgba(255,255,255,.55)', fontFamily:"'DM Sans',sans-serif", transition: 'color .2s' }}
                    onMouseEnter={e => e.target.style.color = '#FF7D2A'}
                    onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,.55)'}
                  >→ {label}</button>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <div style={{ fontFamily:"'Playfair Display',serif", fontWeight: 600, color: '#fff', marginBottom: 18, fontSize: '1rem' }}>Our Products</div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 11 }}>
              {PRODUCT_LINKS.map((item, i) => (
                <li key={i} style={{ fontSize: '.84rem', color: 'rgba(255,255,255,.55)' }}>• {item}</li>
              ))}
            </ul>
          </div>

          {/* WhatsApp CTA */}
          <div>
            <div style={{ fontFamily:"'Playfair Display',serif", fontWeight: 600, color: '#fff', marginBottom: 12, fontSize: '1rem' }}>Get Our Price List</div>
            <p style={{ fontSize: '.83rem', lineHeight: 1.75, marginBottom: 18 }}>
              WhatsApp us for our full wholesale price list with all 200+ products and current rates.
            </p>
            <a href="https://wa.me/919121927878" target="_blank" rel="noopener noreferrer"
              style={{ display: 'flex', alignItems: 'center', gap: 10, background: '#25D366', color: '#fff', padding: '12px 20px', borderRadius: 4, textDecoration: 'none', fontWeight: 700, fontSize: '.9rem', transition: 'background .2s', marginBottom: 24 }}
              onMouseEnter={e => e.currentTarget.style.background = '#1DA851'}
              onMouseLeave={e => e.currentTarget.style.background = '#25D366'}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              WhatsApp Now
            </a>
            <div style={{ display: 'flex', gap: 10 }}>
              {['f','in','▶'].map((s,i) => (
                <div key={i} style={{ width: 34, height: 34, borderRadius: 6, border: '1px solid rgba(255,255,255,.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '.8rem', color: 'rgba(255,255,255,.45)', cursor: 'pointer', transition: 'all .2s' }}
                  onMouseEnter={e => { e.currentTarget.style.background = '#E8610A'; e.currentTarget.style.color = '#fff'; e.currentTarget.style.borderColor = '#E8610A'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = 'rgba(255,255,255,.45)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,.15)'; }}
                >{s}</div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div style={{ borderTop: '1px solid rgba(255,255,255,.07)', padding: '16px 5vw' }}>
        <div className="container" style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10, fontSize: '.77rem', color: 'rgba(255,255,255,.3)' }}>
          <span>© 2026 SLN E SHOP TRADERS Pvt. Ltd. All Rights Reserved.</span>
          <span>🏙️ Proudly serving Hyderabad since 2020</span>
        </div>
      </div>
      <style>{`.footer-cols{grid-template-columns:2fr 1fr 1fr 1.3fr!important;} @media(max-width:900px){.footer-cols{grid-template-columns:1fr 1fr!important;}} @media(max-width:540px){.footer-cols{grid-template-columns:1fr!important;}}`}</style>
    </footer>
  );
}
